import type { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { colorsPalettes } from '@similarweb/styles';

import { Tooltip } from '../../../components/Tooltip';
import { useUserQuery } from '../../../features/user/useUserQuery';
import { useDomainsQuota } from '../../../hooks/useDomainsQuota';
import { StyledExportDropdownOption } from '../CompanyActionsContainer/styles';

import { StyledTooltipTitle, StyledTooltipText, StyledDisabledIcon } from './styles';

export const CompanySaveToListContainer: FC<{ onOpenSaveToListModal: () => void }> = ({ onOpenSaveToListModal }) => {
  const { t } = useTranslation();
  const { data: user } = useUserQuery();

  const uniqueDomainsCount = useDomainsQuota();

  const isDisabled =
    uniqueDomainsCount && user?.opportunitiesLimit ? uniqueDomainsCount >= user?.opportunitiesLimit : false;

  const handleOpenSaveToListModal = () => {
    if (isDisabled) {
      return;
    }
    onOpenSaveToListModal();
  };

  return (
    <Tooltip
      content={
        <>
          <StyledTooltipTitle data-automation="OutQuotaTitle">
            {t('company.save_to_list.out_of_quota.tooltip.title')}
          </StyledTooltipTitle>
          <StyledTooltipText data-automation="OutQuotaText">
            {t('company.save_to_list.out_of_quota.tooltip.text')}
          </StyledTooltipText>
        </>
      }
      enabled={isDisabled}
      placement="top"
      minWidth={271}
    >
      <StyledExportDropdownOption
        isDisabled={isDisabled}
        onClick={handleOpenSaveToListModal}
        data-automation="ExportDdOption"
      >
        {t('company.save_to_list.modal.heading')}
        {isDisabled ? <StyledDisabledIcon iconName="locked" size="sm" iconColor={colorsPalettes.carbon[100]} /> : null}
      </StyledExportDropdownOption>
    </Tooltip>
  );
};
